import { Text } from "@src/appV2/redesign/components/Text";

function getIsMac(): boolean {
  return navigator.platform.toUpperCase().includes("MAC");
}

export function getShortcutHint(): string {
  return getIsMac() ? "⌘K" : "Ctrl+K";
}

function getCopyShortcutHint(): string {
  return getIsMac() ? "⌘C" : "Ctrl+C";
}

export function KeyboardHints() {
  return (
    <>
      <Text color="text.secondary" variant="caption">
        ↑↓ Navigate
      </Text>
      <Text color="text.secondary" variant="caption">
        ⏎ Select
      </Text>
      <Text color="text.secondary" variant="caption">
        {getCopyShortcutHint()} Copy ID
      </Text>
      <Text color="text.secondary" variant="caption">
        Esc Close
      </Text>
    </>
  );
}
